import React from 'react';
import { ConnectorType } from 'services/connectors/types';

type LogoProps = {
  className?: string;
};

const GitHubLogo = ({ className }: LogoProps) => (
  <svg
    aria-hidden="true"
    className={className}
    height="40"
    viewBox="0 0 24 24"
    width="40"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 0C5.37 0 0 5.37 0 12c0 5.3 3.44 9.8 8.21 11.39.6.11.82-.26.82-.58 0-.28-.01-1.04-.02-2.04-3.34.73-4.04-1.61-4.04-1.61-.55-1.39-1.33-1.76-1.33-1.76-1.09-.74.08-.73.08-.73 1.2.09 1.84 1.24 1.84 1.24 1.07 1.83 2.8 1.3 3.49.99.11-.78.42-1.3.76-1.6-2.66-.3-5.46-1.33-5.46-5.93 0-1.31.47-2.38 1.24-3.22-.12-.3-.54-1.52.12-3.18 0 0 1.01-.32 3.3 1.23a11.5 11.5 0 0 1 6 0c2.29-1.55 3.3-1.23 3.3-1.23.66 1.66.24 2.88.12 3.18.77.84 1.24 1.91 1.24 3.22 0 4.61-2.8 5.62-5.48 5.92.43.37.81 1.1.81 2.22 0 1.6-.01 2.89-.01 3.28 0 .32.22.7.82.58A12.01 12.01 0 0 0 24 12c0-6.63-5.37-12-12-12z"
      fill="#24292F"
    />
  </svg>
);

const StravaLogo = ({ className }: LogoProps) => (
  <svg
    aria-hidden="true"
    className={className}
    height="40"
    viewBox="0 0 24 24"
    width="40"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.387 17.944l-2.089-4.116h-3.065L15.387 24l5.15-10.172h-3.066m-7.008-5.599l2.836 5.598h4.172L10.463 0l-7 13.828h4.169"
      fill="#FC4C02"
    />
  </svg>
);

const SubstackLogo = ({ className }: LogoProps) => (
  <svg
    aria-hidden="true"
    className={className}
    height="40"
    viewBox="0 0 24 24"
    width="40"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      fill="#FF6719"
      height="24"
      rx="4"
      width="24"
    />
    <path
      d="M6.2 7.1h11.6v1.7H6.2V7.1zm0 3.4h11.6v8.4L12 16.2 6.2 18.9V10.5z"
      fill="#FFF"
    />
  </svg>
);

const YouTubeLogo = ({ className }: LogoProps) => (
  <svg
    aria-hidden="true"
    className={className}
    height="40"
    viewBox="0 0 24 24"
    width="40"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814z"
      fill="#FF0000"
    />
    <path
      d="M9.545 15.568V8.432L15.818 12l-6.273 3.568z"
      fill="#FFF"
    />
  </svg>
);

const ConnectorLogo = ({
  className,
  type,
}: LogoProps & { type: ConnectorType }) => {
  const normalized = String(type).toUpperCase();
  if (normalized === 'GITHUB') {
    return <GitHubLogo className={className} />;
  }
  if (normalized === 'STRAVA') {
    return <StravaLogo className={className} />;
  }
  if (normalized === 'SUBSTACK') {
    return <SubstackLogo className={className} />;
  }
  if (normalized === 'YOUTUBE') {
    return <YouTubeLogo className={className} />;
  }
  return null;
};

export default ConnectorLogo;
